'use strict';

var _rollupPluginBabelHelpers = require('../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var PropTypes = require('prop-types');
var classnames = require('classnames');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);
var classnames__default = /*#__PURE__*/_interopDefaultLegacy(classnames);

var THEME = {
  yellow: 'yellow',
  green: 'green',
  blue: 'blue',
  purple: 'purple'
};

var ProgressBar = function ProgressBar(_ref) {
  var className = _ref.className,
      value = _ref.value,
      total = _ref.total,
      theme = _ref.theme;

  var _useState = React.useState({
    width: Math.floor(Math.min(value, total) * 100 / total),
    animated: false
  }),
      _useState2 = _rollupPluginBabelHelpers.slicedToArray(_useState, 2),
      styles = _useState2[0],
      setStyles = _useState2[1];

  React.useEffect(function () {
    setTimeout(function () {
      setStyles(_rollupPluginBabelHelpers.objectSpread2({}, styles, {
        animated: true
      }));
    }, 100);
  }, []);
  React.useEffect(function () {
    setStyles(_rollupPluginBabelHelpers.objectSpread2({}, styles, {
      width: Math.floor(Math.min(value, total) * 100 / total)
    }));
  }, [value, theme, total]);
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: classnames__default['default']('ds-atom-new-progress-bar', _rollupPluginBabelHelpers.defineProperty({}, className, className != null))
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: classnames__default['default']('ds-atom-new-progress-bar-value', _rollupPluginBabelHelpers.defineProperty({}, THEME[theme], true), {
      'is-animated': styles.animated
    }),
    style: {
      width: "".concat(styles.width, "%")
    }
  }));
};

ProgressBar.propTypes = {
  className: PropTypes__default['default'].string,
  value: PropTypes__default['default'].number,
  total: PropTypes__default['default'].number,
  theme: PropTypes__default['default'].oneOf(Object.keys(THEME))
};
ProgressBar.defaultProps = {
  className: null,
  value: 0,
  total: 100,
  theme: THEME.yellow
};

module.exports = ProgressBar;
